import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormCreamIcon.tsx
const MedFormCreamIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "cream-icon.svg",
		alt: t("medicationForm.cream")
	});
};

//#endregion
export { MedFormCreamIcon };